import React from "react";
import { useSelector, shallowEqual } from "react-redux"
import SimpleTable from "my-simple-react-table";
import { toAbsoluteUrl } from "../../../../../../../../../../_metronic/_helpers";
import {formatAmount} from "../../../../../../../../../util/Helpers";

const Postions = props => {
    
    const { PUBLIC_URL } = process.env;
    /* Get Account Details from redux */
    const accountDetails = useSelector(({selectedUser}) => {
        return selectedUser.data?.accounts.filter(acc => acc.accountId === props.match.params.accountId)[0]?.details;
    }, shallowEqual);

    const formatAsset = row => {
        return <div className="d-flex align-items-center" style={{whiteSpace: "nowrap"}}>
                    <span className={`svg-icon svg-icon-lg svg-icon-primary mr-5`}>
                        <img
                            alt={row?.asset?.symbol ? row?.asset?.symbol[0] : ""} 
                            height="25px"
                            width="25px"
                            src={row?.asset?.imageUrl}
                            onError={e => {e.target.onerror = null; e.target.src=toAbsoluteUrl("/media/svg/icons/Shopping/Box3.svg")}}
                        />
                    </span>
                    <div>
                        <a href={`${PUBLIC_URL}/instruments/${row?.instrumentId}`} rel="noopener noreferrer" target="_blank" className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                            {row.symbol}
                        </a>
                    </div>
                </div>
    }    
    const formatProfitLoss = row => {
        const diff = row.equityBalance - row.costBasis;
        return <span className={`text-${diff >= 0 ? "primary": "danger"}`}>
                    <b>{diff >= 0 ? "+" : "-"}{formatAmount(accountDetails.currency, Math.abs(diff))}</b>
                    &nbsp; ({(row.costBasis <= 0 ? 0 : Math.abs((diff/row.costBasis) * 100))?.toFixed(2)}%)
                </span>
    }

    return <div className="row">
                <div className="col-12">
                    {/* <!--begin::List Widget 14--> */}
                    <div className="card card-custom gutter-b">
                        {/* <!--begin::Header--> */}
                        <div className="card-header border-0">
                            {/* <!--begin::Title--> */}
                            <div className="card-title pt-5">
                                <h3 className="card-label">
                                    <span className="d-block text-dark h3 font-weight-bolder">Positions</span>
                                    <span className="d-block text-muted mt-2 font-size-sm">Asset currently own in the account</span>
                                </h3>
                            </div>
                        </div>
                        {/* <!--end::Header--> */}
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0">
                            <SimpleTable
                                data={accountDetails.positions}
                                columns={[
                                            {title:"ASSET", format: formatAsset},
                                            {title:"QUANTITY", format: row => row.totalQuantity?.toLocaleString()},
                                            {title:"COST BASIS", format: row => formatAmount(accountDetails.currency, row.costBasis)},
                                            {title:"PRICE", format: row => formatAmount(accountDetails.currency, row.price)},
                                            {title:"VALUE", format: row => <b>{formatAmount(accountDetails.currency, row.equityBalance)}</b>},
                                            {title:"PROFIT/LOSS", format: formatProfitLoss}
                                        ]} 
                            />
                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::List Widget 14--> */}
                </div>

            </div>


}

export default Postions;